export default __webpack_public_path__ + "static/image-7cdee8625665d2f0987c09d148a1d2ba.png";